import React, { PureComponent } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List } from 'react-window';
import {
  Container,
  Header,
  HeaderLabel,
  GearWrapper,
  MessagePreviewList,
} from './elements';
import { MessagePreviewType } from './types';
import { Gear } from '../../atoms/Icons';
import { MessagePreviewItem } from '../../organisms/MessagePreviewItem';
import { words } from '../../../constants';

type Props = {
  conversations: MessagePreviewType;
  messageSelected: string;
  onChangeSelectedMsg: (convoId: string) => void;
  onClickSettings: () => void;
};

class MessagePreview extends PureComponent<Props> {
  renderRow = ({
    index,
    style,
  }: {
    index: number;
    style: React.CSSProperties;
  }) => {
    const { conversations, messageSelected, onChangeSelectedMsg } = this.props;
    const convoId = Object.keys(conversations)[index];
    const convo = conversations[convoId];
    return (
      <div style={style}>
        <MessagePreviewItem
          label={convo.label}
          imgSrc={convo.imgSrc}
          name={convo.name}
          recentMsg={convo.recentMsg}
          isSelected={convoId === messageSelected}
          isAdmin={convo.isAdmin}
          unreadNumber={convo.unreadNumber}
          convoId={convoId}
          onClickMessageItem={onChangeSelectedMsg}
        />
      </div>
    );
  };

  render = (): React.ReactElement => {
    const { conversations, onClickSettings, messageSelected } = this.props;

    return (
      <Container>
        <Header>
          <HeaderLabel>{words.mailboxHeader}</HeaderLabel>
          <GearWrapper onClick={onClickSettings}>
            <Gear />
          </GearWrapper>
        </Header>
        <MessagePreviewList>
          <AutoSizer>
            {({ height, width }) => (
              <List
                {...conversations}
                {...messageSelected}
                height={height}
                width={width}
                itemCount={Object.keys(conversations).length}
                itemSize={65}>
                {this.renderRow}
              </List>
            )}
          </AutoSizer>
        </MessagePreviewList>
      </Container>
    );
  };
}

export default MessagePreview;
